// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-preview-wrapper {
    background: #fcf8e3;
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 8px 16px rgba(0,0,0,0.1);
    font-family: 'Segoe UI', sans-serif;
  }
  
  .form-title {
    text-align: center;
    color: #144040;
    font-size: 1.4rem;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .form-question-card {
    background: #fffdf6;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid #eee;
  }
  
  .form-question-text {
    font-weight: bold;
    margin-bottom: 12px;
    color: #144040;
  }
  
  .form-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .form-option {
    font-size: 0.95rem;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .form-input,
  .form-textarea {
    width: 100%;
    margin-top: 10px;
    padding: 10px;
    border-radius: 6px;
    border: 1px solid #ccc;
    font-size: 0.95rem;
    background: #fefefe;
    color: #444;
  }
  
  .form-input::placeholder,
  .form-textarea::placeholder {
    color: #999;
  }
  
  .form-textarea {
    resize: vertical;
    min-height: 60px;
  }
  `, "",{"version":3,"sources":["webpack://./src/home/Tools/FormPreview.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB","sourcesContent":[".form-preview-wrapper {\n    background: #fcf8e3;\n    padding: 20px;\n    border-radius: 16px;\n    box-shadow: 0 8px 16px rgba(0,0,0,0.1);\n    font-family: 'Segoe UI', sans-serif;\n  }\n  \n  .form-title {\n    text-align: center;\n    color: #144040;\n    font-size: 1.4rem;\n    font-weight: bold;\n    margin-bottom: 20px;\n  }\n  \n  .form-question-card {\n    background: #fffdf6;\n    border-radius: 12px;\n    padding: 20px;\n    border: 1px solid #eee;\n  }\n  \n  .form-question-text {\n    font-weight: bold;\n    margin-bottom: 12px;\n    color: #144040;\n  }\n  \n  .form-options {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .form-option {\n    font-size: 0.95rem;\n    color: #333;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .form-input,\n  .form-textarea {\n    width: 100%;\n    margin-top: 10px;\n    padding: 10px;\n    border-radius: 6px;\n    border: 1px solid #ccc;\n    font-size: 0.95rem;\n    background: #fefefe;\n    color: #444;\n  }\n  \n  .form-input::placeholder,\n  .form-textarea::placeholder {\n    color: #999;\n  }\n  \n  .form-textarea {\n    resize: vertical;\n    min-height: 60px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
